/**
 * The one price line every filter CARD renders (FRIDGE-726): a single
 * filter reads "From $24.99"; a multi-pack reads "From $15.79 per filter"
 * with the pack price beneath it ("3-pack $47.37"); an unpriced listing says
 * so. Arithmetic and wording come from lib/filters/pack.ts — no surface does
 * its own division. Plain markup, no hooks: renders in server and client
 * components alike.
 */
import { formatCents } from '@/lib/format-utils'
import { packEconomics, packLabel } from '@/lib/filters/pack'

export function PackPrice({
  title,
  cents,
  size = 'sm',
}: {
  title: string | null | undefined
  /** The listing's live price in cents (lowest_price_cents), or null. */
  cents: number | null | undefined
  size?: 'sm' | 'md'
}) {
  const eco = packEconomics(title, cents)
  const priceClass = size === 'md' ? 'text-base font-bold text-gray-900' : 'font-semibold text-gray-900'
  if (eco.perFilterCents === null || eco.packCents === null) {
    return <p className="text-xs text-gray-500">No live price right now</p>
  }
  if (!eco.isPack) {
    return (
      <p className="text-sm">
        <span className="text-xs font-normal text-gray-500">From</span> <span className={priceClass}>{formatCents(eco.packCents)}</span>
      </p>
    )
  }
  return (
    <p className="text-sm">
      <span className="text-xs font-normal text-gray-500">From</span> <span className={priceClass}>{formatCents(eco.perFilterCents)}</span>{' '}
      <span className="text-xs font-normal text-gray-500">per filter</span>
      <span className="block text-xs text-gray-500">
        {packLabel(eco.quantity)} {formatCents(eco.packCents)}
      </span>
    </p>
  )
}
